import { memo } from 'react';
import { DialogContent } from 'client/components/Dialog/DialogContent';
import { Skeleton } from 'client/components/Skeleton';

export const DialogContentSkeleton = memo(() => (
  <DialogContent
    title={<Skeleton width="60%" />}
    description={<Skeleton width="80%" />}
    icon={<Skeleton type="icon" />}
    actions={<Skeleton type="button" width={100} />}
    dismissable={false}
  >
    <Skeleton width="100%" height={75} />
    <Skeleton style={{ marginTop: 6, width: '60%' }} />
  </DialogContent>
));
